import React from 'react';

const ActiveTag = ({ status }: { status: string }) => {
  return (
    <div
      className={` w-fit min-h-fit  ${
        status.toLowerCase() === 'completed'
          ? 'text-[#46AE31] bg-[#EEF9EB]'
          : status.toLowerCase() === 'active'
          ? 'text-[#FF9500] bg-[#FFF4E5]'
          : 'text-[#858585] bg-[#F0F0F0]'
      } py-[2px] px-3 text-sm rounded-full  flex justify-center gap-2 items-center`}>
      <p className='text-sm font-medium'>{status}</p>
    </div>
  );
};

export default ActiveTag;
